import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

interface IBigHeadingProps {
  /** Отрендерить как */
  as: keyof React.ReactHTML;
  /** Цвет заголовка */
  color?: 'white_100' | 'black_100';
  /** Выравнивание текста */
  textAlign?: 'left' | 'right' | 'center';
}

/**
 * Компонент заголовка размером 36px, которого нет в ui-kit.
 * По-умолчанию черного цвета и выровнен по левому краю.
 */
export const BigHeading: React.FC<React.PropsWithChildren<IBigHeadingProps>> = ({
  as: AsComponent = 'div',
  color = 'black_100',
  textAlign = 'left',
  children,
}) => {
  return (
    <AsComponent className={cn(styles['heading'], styles[`color-${color}`], styles[`text-align-${textAlign}`])}>
      {children}
    </AsComponent>
  );
};
